import { createContext, useContext } from 'react'
import type { OwnerDeleteDisposition } from '@/lib/backupVaultApi'

export type ServerCancellationRequest = {
  serverUuid: string
  serverName: string
  disposition: OwnerDeleteDisposition
}

export const ServerCancellationContext = createContext<((request: ServerCancellationRequest) => void) | null>(null)

export function useServerCancellation() {
  const begin = useContext(ServerCancellationContext)
  if (!begin) throw new Error('Server cancellation requires its application provider.')
  return begin
}
